import React from 'react';
import axios from 'axios';

import PageHeader from '../../Common/PageHeader';

import TenantService from '../../../Service/TenantService';
import Loader from '../../../Component/Common/Loader';
import { toastError, toastForTenant } from '../../../SweetAlertUtil/util';

const WORKFLOWS = {
	1: 'SetupNewLoan',
	2: 'SetupExistingLoan',
	3: 'BuySomething'
};

class Index extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			_deployments: null,
			_isLoading: false,
			_tenant: null
		};
	}

	onChange = (e, i) => {
		const _deployments = this.state._deployments;
		_deployments[i]._fileUploaded = e.target.files[0] || null;
		this.setState({
			_deployments
		});
	};

	uploadNewBpmn = async i => {
		try {
			const _deployments = this.state._deployments;
			this.setState({ _isLoading: true });
			const response = await TenantService.getSignedUrl(this.props.match.params.id, _deployments[i].id);
			await axios.put(response.signedUrl, _deployments[i]._fileUploaded, {
				headers: {
					'Content-Type': 'application/octet-stream'
				}
			});
			await TenantService.redeployNewBpmn(this.props.match.params.id, _deployments[i].id);
			_deployments[i]._fileUploaded = null;
			this.setState({ _isLoading: false, _deployments });
			if (response) {
				toastForTenant('Your new bpmn file is deployed successfully');
			} else {
				toastError('something went wrong');
			}
		} catch (error) {
			this.setState({ _isLoading: false });
			toastError('something went wrong');
		}
	};

	downloadBpmn = async bpmnId => {
		this.setState({ _isLoading: true });
		const response = await TenantService.downloadTenantBpmn(this.props.match.params.id, bpmnId);
		if (response) {
			this.setState({ _isLoading: false });
			window.open(response.signedUrl);
		}
	};

	setAllTenants = async () => {
		const response = await TenantService.getById(this.props.match.params.id);
		this.setState({
			_deployments: response.bpmn_deployments[0] === null ? null : response.bpmn_deployments,
			_tenant: response
		});
	};

	onToggle = async (i, bpmn) => {
		try {
			this.setState({ _isLoading: true });
			const activeWorkflow = await this.state._deployments.filter(workflow => {
				return workflow.is_active === true;
			});
			if (activeWorkflow.length < 2 && bpmn.is_active) {
				this.setState({ _isLoading: false });
				toastError('Yor atleast need to have 1 active workflow');
				return;
			}
			await TenantService.toggleBpmnStatus(this.props.match.params.id, bpmn.id);
			const _deployments = this.state._deployments;
			_deployments[i].is_active = !this.state._deployments[i].is_active;
			await this.setState({
				_deployments,
				_isLoading: false
			});
			toastForTenant(
				`You have successfully ${this.state._deployments[i].is_active ? 'activated' : 'deactivated'} the bpmn`
			);
		} catch (e) {
			this.setState({ _isLoading: false });
			console.log(e);
		}
	};

	componentDidMount() {
		this.setAllTenants();
	}

	render() {
		if (!this.state._deployments) {
			return 'Loading...';
		}
		return (
			<>
				<PageHeader
					text={`Deployments - ${this.state._tenant !== null ? this.state._tenant.short_name : ''}`}
				/>
				<div className="card" style={{ overflow: 'auto' }}>
					<div className="card-body">
						<table className="table table-bordered">
							<thead>
								<tr>
									<th style={{ width: '10%' }}>#</th>
									<th>Workflow</th>
									<th>Deployed Bpmn</th>
									<th>Action</th>
									<th style={{ width: '40%' }}>Update Workflow</th>
									<th>Status</th>
								</tr>
							</thead>
							<tbody>
								{this.state._deployments !== null
									? this.state._deployments.map((data, index) => (
											<tr key={index}>
												<td>{index + 1}.</td>
												<td>{WORKFLOWS[data.loan_workflow_id]}</td>
												<td>{data.s3_key}</td>
												<td>
													<button
														className="btn btn-block btn-primary"
														onClick={() => {
															this.downloadBpmn(data.id);
														}}
														type="button">
														Download
													</button>
												</td>
												<td style={{ display: 'flex' }}>
													<div className="custom-file">
														<input
															className="custom-file-input"
															id="customFile"
															name="customFile"
															onChange={e => this.onChange(e, index)}
															type="file"
														/>
														<label
															className="custom-file-label overflow-hidden"
															htmlFor="customFile">
															{data._fileUploaded?.name || 'Choose file'}
														</label>
													</div>
													<button
														className="btn btn-block btn-success"
														disabled={!data._fileUploaded}
														onClick={() => {
															this.uploadNewBpmn(index);
														}}
														style={{ width: '30%', marginLeft: '10px' }}
														type="button">
														Upload
													</button>
												</td>
												<td>
													<div className="custom-control custom-switch">
														<input
															checked={data.is_active}
															className="custom-control-input"
															id={`bpmn-status-switch-${index}`}
															onChange={() => this.onToggle(index, data)}
															type="checkbox"
														/>
														<label
															className="custom-control-label"
															htmlFor={`bpmn-status-switch-${index}`}>
															{data.is_active}
														</label>
													</div>
												</td>
											</tr>
									  ))
									: null}
							</tbody>
						</table>
					</div>
					{this.state._isLoading ? <Loader /> : null}
				</div>
			</>
		);
	}
}

export default Index;
